module.exports = __webpack_public_path__ + "static/media/loader.07f010bd.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/loader.gif
// module id = 1293
// module chunks = 0